(function () {
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}


var $3d28d7f1aac198f5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.board = initialState || [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.score = 0;
        this.status = "idle";
        this.gameScore = document.querySelector(".game-score");
        this.firstMove = true;
        this.cells = document.querySelectorAll(".field-cell");
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "bindControls",
            value: function bindControls() {
                var _this = this;
                document.addEventListener("keydown", function(e) {
                    if (_this.status !== "playing") return;
                    e.preventDefault();
                    switch(e.key){
                        case "ArrowLeft":
                            _this.moveLeft();
                            break;
                        case "ArrowRight":
                            _this.moveRight();
                            break;
                        case "ArrowUp":
                            _this.moveUp();
                            break;
                        case "ArrowDown":
                            _this.moveDown();
                            break;
                        default:
                    }
                });
            }
        },
        {
            key: "hasBoardChanged",
            value: function hasBoardChanged(oldBoard, newBoard) {
                return JSON.stringify(oldBoard) !== JSON.stringify(newBoard);
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this, _loop = function(r) {
                    var row = _this.board[r];
                    row = row.filter(function(v) {
                        return v !== 0;
                    });
                    for(var c = 0; c < row.length - 1; c++)if (row[c] === row[c + 1]) {
                        row[c] *= 2;
                        row[c + 1] = 0;
                        _this.score += row[c];
                    }
                    row = row.filter(function(v) {
                        return v !== 0;
                    });
                    while(row.length < 4)row.push(0);
                    _this.board[r] = row;
                };
                var oldBoard = JSON.parse(JSON.stringify(this.board));
                for(var r = 0; r < 4; r++)_loop(r);
                if (this.hasBoardChanged(oldBoard, this.board)) {
                    if (this.firstMove) this.firstMove = false;
                    this.addNewCell();
                    if (!this.checkWin()) this.checkLose();
                    this.render();
                }
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this, _loop = function(r) {
                    var row = _this.board[r].filter(function(v) {
                        return v !== 0;
                    });
                    for(var c = row.length - 1; c > 0; c--)if (row[c] === row[c - 1]) {
                        row[c] *= 2;
                        row[c - 1] = 0;
                        _this.score += row[c];
                    }
                    row = row.filter(function(el) {
                        return el !== 0;
                    });
                    while(row.length < 4)row.unshift(0);
                    _this.board[r] = row;
                };
                var oldBoard = JSON.parse(JSON.stringify(this.board));
                for(var r = 0; r < 4; r++)_loop(r);
                if (this.hasBoardChanged(oldBoard, this.board)) {
                    if (this.firstMove) this.firstMove = false;
                    this.addNewCell();
                    if (!this.checkWin()) this.checkLose();
                    this.render();
                }
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this, _loop = function(c) {
                    var column = [
                        _this.board[0][c],
                        _this.board[1][c],
                        _this.board[2][c],
                        _this.board[3][c]
                    ];
                    column = column.filter(function(v) {
                        return v !== 0;
                    });
                    for(var i = 0; i < column.length - 1; i++)if (column[i] === column[i + 1]) {
                        column[i] *= 2;
                        _this.score += column[i];
                        column[i + 1] = 0;
                    }
                    column = column.filter(function(v) {
                        return v !== 0;
                    });
                    while(column.length < 4)column.push(0);
                    for(var r = 0; r < 4; r++)_this.board[r][c] = column[r];
                };
                var oldBoard = JSON.parse(JSON.stringify(this.board));
                for(var c = 0; c < 4; c++)_loop(c);
                if (this.hasBoardChanged(oldBoard, this.board)) {
                    if (this.firstMove) this.firstMove = false;
                    this.addNewCell();
                    if (!this.checkWin()) this.checkLose();
                    this.render();
                }
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this, _loop = function(c) {
                    var column = [
                        _this.board[0][c],
                        _this.board[1][c],
                        _this.board[2][c],
                        _this.board[3][c]
                    ];
                    column = column.filter(function(v) {
                        return v !== 0;
                    });
                    for(var i = column.length - 1; i > 0; i--)if (column[i] === column[i - 1]) {
                        column[i] *= 2;
                        _this.score += column[i];
                        column[i - 1] = 0;
                    }
                    column = column.filter(function(v) {
                        return v !== 0;
                    });
                    while(column.length < 4)column.unshift(0);
                    for(var r = 0; r < 4; r++)_this.board[r][c] = column[r];
                };
                var oldBoard = JSON.parse(JSON.stringify(this.board));
                for(var c = 0; c < 4; c++)_loop(c);
                if (this.hasBoardChanged(oldBoard, this.board)) {
                    if (this.firstMove) this.firstMove = false;
                    this.addNewCell();
                    if (!this.checkWin()) this.checkLose();
                    this.render();
                }
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.board;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "addNewCell",
            value: function addNewCell() {
                var empty = [];
                for(var r = 0; r < 4; r++){
                    for(var c = 0; c < 4; c++)if (this.board[r][c] === 0) empty.push([
                        r,
                        c
                    ]);
                }
                if (empty.length === 0) return null;
                var _empty_Math_floor = (0, $efec029548ccee7f$export$71511d61b312f219)(empty[Math.floor(Math.random() * empty.length)], 2), row = _empty_Math_floor[0], col = _empty_Math_floor[1];
                this.board[row][col] = Math.random() < 0.9 ? 2 : 4;
                return [
                    row,
                    col
                ];
            }
        },
        {
            key: "render",
            value: function render() {
                for(var r = 0; r < 4; r++)for(var c = 0; c < 4; c++){
                    var value = this.board[r][c];
                    var cell = this.cells[r * 4 + c];
                    cell.className = "field-cell";
                    cell.textContent = value === 0 ? "" : value;
                    if (value > 0) cell.classList.add("field-cell--".concat(value));
                    else cell.classList.add("empty");
                }
                this.gameScore.textContent = this.score;
                this.renderStatus();
            }
        },
        {
            key: "renderStatus",
            value: function renderStatus() {
                var msgStart = document.querySelector(".message-start");
                var msgWin = document.querySelector(".message-win");
                var msgLose = document.querySelector(".message-lose");
                msgStart.classList.add("hidden");
                msgWin.classList.add("hidden");
                msgLose.classList.add("hidden");
                if (this.status === "idle") msgStart.classList.remove("hidden");
                if (this.status === "win") msgWin.classList.remove("hidden");
                if (this.status === "lose") msgLose.classList.remove("hidden");
            }
        },
        {
            key: "checkWin",
            value: function checkWin() {
                for(var r = 0; r < 4; r++){
                    for(var c = 0; c < 4; c++)if (this.board[r][c] === 2048) {
                        this.status = "win";
                        return true;
                    }
                }
                return false;
            }
        },
        {
            key: "checkLose",
            value: function checkLose() {
                if (this.board.flat().includes(0)) return false;
                for(var r = 0; r < 4; r++)for(var c = 0; c < 4; c++){
                    if (c < 3 && this.board[r][c] === this.board[r][c + 1] || r < 3 && this.board[r][c] === this.board[r + 1][c]) return false;
                }
                this.status = "lose";
                return true;
            }
        },
        {
            key: "start",
            value: function start() {
                this.status = "playing";
                this.addNewCell();
                this.addNewCell();
                this.firstMove = false;
                this.render();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.board = [
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ]
                ];
                this.score = 0;
                this.status = "idle";
                this.firstMove = true;
                this.render();
            }
        }
    ]);
    return Game;
}();


var $197cd56b15c33885$var$buttonStart = document.querySelector(".start");
var $197cd56b15c33885$var$game = new (0, $3d28d7f1aac198f5$export$2e2bcd8739ae039)();
$197cd56b15c33885$var$buttonStart.addEventListener("click", function() {
    if ($197cd56b15c33885$var$buttonStart.classList.contains("start")) {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$game.bindControls();
        $197cd56b15c33885$var$buttonStart.classList.remove("start");
        $197cd56b15c33885$var$buttonStart.classList.add("restart");
        $197cd56b15c33885$var$buttonStart.textContent = "Restart";
    } else {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$buttonStart.classList.remove("restart");
        $197cd56b15c33885$var$buttonStart.classList.add("start");
        $197cd56b15c33885$var$buttonStart.textContent = "Start";
    }
});

})();
//# sourceMappingURL=index.3c37e521.js.map
